'use client';

/**
 * RendererEmptyState
 *
 * Shared bordered Box wrapper around `EmptyState` used by every Astor tool
 * renderer for empty-result and parse-failure paths. Centralising the
 * `borderRadius` / `border` / `my` styling so a future visual tweak hits
 * one file instead of fifteen.
 */

import Box from '@mui/material/Box';
import type { ReactElement } from 'react';
import { EmptyState } from '../EmptyState';

export interface RendererEmptyStateProps {
  title: string;
  description?: string;
}

export const RendererEmptyState = ({ title, description }: RendererEmptyStateProps): ReactElement => (
  <Box sx={{ my: 1.5, borderRadius: 2, border: 1, borderColor: 'divider' }}>
    <EmptyState title={title} description={description} />
  </Box>
);

export default RendererEmptyState;
